import React from "react";
import './pages.css'
import './pagesResponsiveStylesheet.css'
import Icon from "../Assets/IconLibrary/Icon";
import Popup from "reactjs-popup";
import Scrollbars from "react-custom-scrollbars-2";
import Suresh from '../Assets/Images/Company/suresh.svg'
import JiaZeng from '../Assets/Images/Company/JiaZeng.png'
import StartUp from "../Assets/Images/Company/accelerate.png";
import HeadSection from "../Components/HeadSection/HeadSection";
import TeamMissionUpperBackground from "../Assets/Images/Illustrations/team_missing_upper_background.svg";
import TeamMissionLowerBackground from "../Assets/Images/Illustrations/team_mission_lower_background.svg";
import TeamChatBot from "../Assets/Images/Illustrations/team_chatbot_background.svg";

import TeamProfileBackgroundLeft from "../Assets/Images/Company/profile_background.svg";
import TeamProfileBackgroundRight from "../Assets/Images/Company/profile_right_background.svg";
import {onLoadImages} from "../Components/CommonMethods";
import Illustration from "../Assets/Images/Illustrations/Illustration";
import VisibilitySensor from "react-visibility-sensor";

class Company extends React.Component {
    constructor(props) {
        super(props);
        this.containerRef = React.createRef()
        this.state = {
            imageLoaded: false,
            autoPlay: false,
            contextPopup: false,
            contextPopupTitle: "Company",
            contextPopupImage: StartUp,
            contextPopupTag: "About AnyGen AI",
            textInfo: [],
            showVideo: false,
            leadershipTeam: [
                {
                    Image: Suresh,
                    Name: 'Suresh Vallabhaneni',
                    Position: 'Founder & CEO',
                    Data: ['Suresh Vallabhaneni is a serial entrepreneur with over 24 years of experience in the software industry. Prior to AnyGen AI, Suresh was the founder and CEO of Zing Wallet, a mobile payments startup and Adagesoft, a solutions provider. Before venturing into startups, Suresh has worked at various Fortune 500 companies like Goldman Sachs, Freddie Mac and technology companies like BEA Systems.',
                        'Suresh has a Masters in Computer Science from Andhra University India and Certificate in Entrepreneurship from Stanford Graduate School of Business.'
                    ]
                },
                {
                    Image: JiaZeng,
                    Name: 'Jia Zeng',
                    Position: 'Co-Founder',
                    Data: ['Jia Zeng holds a BS in Computer Science with a minor in Machine Learning; she is passionate about building high-performance computing systems in the space of AI and likes to paint to reenergize her.']
                },
            ],
            teamMemberPopup: false,
            memberName: '',
            context: {
                about: [
                    "AnyGen AI is a data-driven intelligence platform that helps people quickly turn\n" +
                    "their data into actionable insights. Founded to democratize AI and make it\n" +
                    "accessible to everyone, AnyGen AI provides an intuitive, easy-to-use interface\n" +
                    "based on the user's skillset. With just a few clicks, anyone can create an\n" +
                    "intelligent application that learns from new inputs without ever writing code.",

                    "Since 2019, AnyGen AI has been helping businesses turn their data into\n" +
                    "powerful, valuable insights in the blink of an eye. The perfect tool for anyone\n" +
                    "who wants to make their business smarter without learning how to code,\n" +
                    "AnyGen AI empowers businesses of all sizes to create and use AI solutions in\n" +
                    "minutes.",

                    "Headquartered in Palo Alto, California, AnyGen AI allows business executives,\n" +
                    "engineers, and organizational leaders to quickly and easily create custom AI\n" +
                    "solutions that identify, address, and solve unique, specific business\n" +
                    "problems. Designed to provide a streamlined, simplified, and intuitive user\n" +
                    "experience fueled by artificial intelligence, AnyGen AI delivers an adaptive\n" +
                    "interface that makes it simple for anyone to create AI solutions quickly and\n" +
                    "effectively.",

                    "As the volume and complexity of the data grows, finding the signal in the noise\n" +
                    "becomes increasingly difficult. Without the help of AI, most businesses\n" +
                    "cannot make sense of their data and turn it into valuable insights. As enterprises are collecting more data than ever before, the collection of data has grown at an unprecedented rate.. This influx of data has made it difficult for\n" +
                    "businesses to keep up with the latest trends and make informed decisions.",

                    "AnyGen AI was born out of a commitment to address and solve this problem by\n" +
                    "simplifying AI and making it more accessible and valuable for businesses of\n" +
                    "all sizes. We developed our groundbreaking, innovative AI Lifecycle platform\n" +
                    "to help our customers transform their data into actionable insights without\n" +
                    "coding or expertise. With AnyGen AI, you can get insights from your data in\n" +
                    "minutes instead of months. You'll be able to make decisions quickly and\n" +
                    "efficiently to stay ahead of the competition.",
                ],
                vision: [
                    "AnyGen AI is an AI Lifecycle platform that believes in something bigger. Our\n" +
                    "mission is to be an industry disrupter and a difference-maker by providing a\n" +
                    "powerful way for businesses to harness the power of their data. AnyGen AI is\n" +
                    "the culmination of years of passion, determination, and personal experiences\n" +
                    "that have been developed throughout the career of AnyGen’s founding team.\n" +
                    "Our love for startups and technology is at the core of what we do, and we\n" +
                    "have remained committed to revolutionizing the landscape of business and\n" +
                    "data in the 21st century.",

                    "We believe \"good enough\" is never enough, and this belief is at the very\n" +
                    "heart of what we do. At AnyGen AI, our goal is to make sophisticated\n" +
                    "technology accessible to businesses ready to take their success to the next\n" +
                    "level by making AI technology more accessible to all.",
                ]
            }
        }
    }

    componentDidMount() {
        let imageLoaded = onLoadImages(this.containerRef)
        this.setState({
            imageLoaded
        })
    }

    teamMemberInfo = (name) => {
        let leadershipTeam = [...this.state.leadershipTeam];

        leadershipTeam.map(leadershipTeam => {
                if (leadershipTeam.Name === name) {
                    this.setState({teamMemberPopup: !this.state.teamMemberInfo, memberName: name})
                }
            }
        )
    };

    openDetailedInfo = (textInfo, title, image, contextPopupTag) => {
        this.setState({
            contextPopup: true,
            textInfo,
            contextPopupTitle: title,
            contextPopupImage: image,
            contextPopupTag,
        })
    }

    render() {
        return (
            <div className='company' ref={this.containerRef}>
                <HeadSection keyword={"company"}/>
                {/*{*/}
                {/*    this.state.imageLoaded !== true &&*/}
                {/*    <div className="company-about">*/}
                {/*        <PianoLoading title={"Loading ..."}/>*/}
                {/*    </div>*/}
                {/*}*/}

                <div className='company-about'>
                    <div className="company-team-image-section">
                        <div className="company-team-image-container">
                            <div className="company-about-image"/>
                        </div>
                        <img src={TeamChatBot} alt={"Team Image"} loading={"lazy"} className="company-team-background"/>
                    </div>

                    <div className='company-about-content'>
                        <h2 className='default-header-style company-main-title'>
                            Chatbot Any Data</h2>
                        <div className='company-text company-text-about'>
                            <p>
                                Enterprises amass data having valuable inferential logic that is typically very time
                                consuming, laborious and expensive to retrieve. With the advent of Large Language Models
                                and Generative AI it's now possible to do it faster. However most generative AI products
                                are too expensive and lack the capabilities needed to support enterprises’ Generative AI
                                Applications Lifecycle.
                            </p>
                            <p>
                                AnyGen AI enables Any Enterprises to chatbot their data from any source - sql, nosql,
                                saas databases or files. Enterprises can chatbot their data that’s distributed across
                                any sources with or without coding.
                            </p>
                        </div>

                    </div>
                </div>
                <div className='company-about'>
                    <div className='company-about-content'>
                        <h2 className='default-header-style company-main-title'>Our Mission/ Vision</h2>
                        <div className='company-text company-text-about'>
                            AnyGen AI’s vision is to enable any enterprise to be able to generate intelligence from
                            their data and consumption ready Gen AI applications.

                        </div>

                        {/*<Button onClick={this.openDetailedInfo.bind(this, this.state.context.vision, "Our vision",StartUp, "")}*/}
                        {/*width={"150px"}*/}
                        {/*text="See More"*/}
                        {/*/>*/}

                    </div>
                    <div className="company-team-image-section">
                        <div className="company-team-image-container">
                            <div className="company-about-image mission-vision"/>
                        </div>
                        <img src={TeamMissionUpperBackground} loading={"lazy"}
                             alt={"Team Image"}
                             className="company-team-upper-background"/>
                        <img src={TeamMissionLowerBackground} loading={"lazy"}
                             alt={"Team Image"}
                             className="company-team-lower-background"/>

                    </div>

                </div>

                <div className='team-anyGen-container'>
                    {/*<div className='company-active-title'>Team AnyGen AI</div>*/}
                    <h2 className='default-header-style company-main-title'>Our Leadership Team</h2>
                    <div className='team-anyGen-image-container'>
                        {
                            this.state.leadershipTeam.map((leaderTeam, tid) =>
                                <div className="team-image-profile-container"
                                     onClick={() => this.teamMemberInfo(leaderTeam.Name)}>
                                    <button className='team-anyGen-image'>
                                        <img src={leaderTeam.Image}
                                             loading={"lazy"}
                                             width={"100%"}
                                             height={"100%"}
                                             className={tid / 2 !== 0 ? "team-anygen-pofile-img right-image" : "team-anygen-pofile-img"}
                                             alt={leaderTeam.Name}/>

                                        <div className='default-header-style company-main-title'
                                             style={{fontSize: 24, marginTop: 25}}>{leaderTeam.Name}
                                        </div>
                                        <div
                                            className='company-text company-position'>{leaderTeam.Position}</div>
                                    </button>
                                    {
                                        tid / 2 !== 0 ?
                                            <img src={TeamProfileBackgroundRight} loading={"lazy"}
                                                 alt={"Glass Background"}
                                                 className="team-image-profile-background"/>
                                            :
                                            <img src={TeamProfileBackgroundLeft} loading={"lazy"}
                                                 alt={"Glass Background"}
                                                 className="team-image-profile-background"/>

                                    }
                                </div>
                            )
                        }
                    </div>
                </div>

                <Popup open={this.state.teamMemberPopup}
                       overlayStyle={{backgroundColor: 'rgba(0,0,0,70%)'}}
                       onClose={() => this.setState({teamMemberPopup: false})}
                       contentStyle={{
                           background: "transparent",
                           padding: 0,
                           border: "none",
                           borderRadius: "none",
                           minWidth: "100px"
                       }}
                >
                    {
                        this.state.leadershipTeam.map(leaderList =>
                            this.state.memberName === leaderList.Name &&
                           <div className="profile-detail-info-popup">
                               <div className="profile-detail-info-layout">
                                   <div className='company-team-info-container'>

                                       <div className="home-layout-background-division">

                                           <div className="home-landing-background-header">
                                               <Illustration name={"BlueEllipse"} className="hologram-header-image"/>
                                           </div>
                                           <div className="home-landing-background">
                                               <Illustration name={"NeuralNetwork"} className="hologram-background-image"/>
                                               <Illustration name={"GreenEllipse"}
                                                             className="hologram-background-image background"/>
                                           </div>

                                           <div className="home-landing-background">
                                               <VisibilitySensor onChange={this.onVisibilityChange} partialVisibility={true}>
                                                   <Illustration name={"NeuralNetwork"}
                                                                 className={this.state.showNeural ? "hologram-background-image" : "hologram-background-image hide"}/>
                                               </VisibilitySensor>
                                               <Illustration name={"BlueEllipse"}
                                                             className="hologram-background-image background"/>
                                           </div>

                                           <div className="home-landing-background">
                                               <Illustration name={"NeuralNetwork"} className="hologram-background-image"/>
                                               <Illustration name={"GreenEllipse"}
                                                             className="hologram-background-image background"/>
                                           </div>
                                       </div>
                                       <button className='company-team-info-close'
                                               onClick={() => this.setState({teamMemberPopup: !this.state.teamMemberPopup})}>
                                           <Icon name={'close'} size={20} colorList={["white"]}/>
                                       </button>
                                       <div className='company-team-info-image-container'>
                                           <img src={leaderList.Image}
                                                loading={"lazy"}
                                                width={150}
                                                height={"100%"}
                                                alt={leaderList.Name}/>

                                           <div style={{
                                               gap: 10,
                                               display: 'flex',
                                               flexDirection: 'column',
                                           }}>
                                               <h1 className='default-header-style popup-company-main-title'>{leaderList.Name}
                                               </h1>
                                               <div
                                                   className='company-position'>{leaderList.Position}
                                               </div>
                                           </div>
                                       </div>
                                       <div className='company-team-info-body'
                                            style={{
                                                gap: 20,
                                                display: 'flex',
                                                flexDirection: 'column'
                                            }}>

                                           {
                                               leaderList.Data.map(leaderInfo =>
                                                   <div>{leaderInfo}</div>
                                               )
                                           }

                                       </div>
                                   </div>
                               </div>
                           </div>
                        )
                    }


                </Popup>

                <Popup contentStyle={{
                    background: "transparent",
                    padding: 0,
                    border: "none",
                    borderRadius: "none",
                }}
                       open={this.state.contextPopup}
                       overlayStyle={{backgroundColor: 'rgba(0,0,0,70%)'}}
                       onClose={() => this.setState({contextPopup: false})}>
                    <div className="context-popup">
                        <div className="context-popup--header">
                            <button className="context-popup-close-btn"
                                    onClick={() => this.setState({contextPopup: false})}>
                                <Icon name={'close'} size={20}/>
                            </button>
                            <div className="context-popup-tag">{this.state.contextPopupTag}</div>
                            <div className="context-popup-title">{this.state.contextPopupTitle}</div>
                        </div>
                        <Scrollbars style={{height: '72vh'}}
                                    autoHide
                                    autoHideTimeout={500}
                                    autoHideDuration={200}>
                            <div className="context-popup--body">


                                {
                                    this.state.textInfo.map((text) =>
                                        <p>{text}</p>
                                    )
                                }

                            </div>
                        </Scrollbars>
                    </div>

                </Popup>
            </div>
        )
    }
}

export default Company;